// ── Resume dropdown (header, top right) ───────────────────────────────
export default function initResumeDropdown() {
  const dd  = document.getElementById("resume-dd");
  const btn = document.getElementById("resume-dd-btn");
  if (!dd || !btn) return;

  const setOpen = (open) => {
    dd.classList.toggle("is-open", open);
    btn.setAttribute("aria-expanded", String(open));
  };

  btn.addEventListener("click", (e) => {
    e.stopPropagation();
    setOpen(!dd.classList.contains("is-open"));
  });
  dd.querySelectorAll("a").forEach((a) => a.addEventListener("click", () => setOpen(false)));
  document.addEventListener("click", (e) => { if (!dd.contains(e.target)) setOpen(false); });
  document.addEventListener("keydown", (e) => { if (e.key === "Escape") setOpen(false); });
}
